import { memo, useEffect } from 'react';
import {
	initialize as gaInit,
	set as gaSet,
	pageview as gaPageview,
} from 'react-ga';
import { connect } from 'unistore/react';
import { useRouter } from 'next/router';

import {
	monitorActions,
	actionsCombiner,
	redirectURLActions,
} from '@utils/store/actions';

gaInit('UA-110186270-1', {
	// debug: process.env.NODE_ENV === 'development',
	testMode: process.env.NODE_ENV === 'development',
});

const trackPage = page => {
	setTimeout(() => {
		requestAnimationFrame(() => {
			gaSet({
				page,
			});
			gaPageview(page);
			if (window.fbq) {
				window.fbq('track', 'PageView');
			}
		});
	}, 350);
};

const TrackerComp = memo(
	({ __setURLLocationNRedirect, __pushToMonitorEvents }) => {
		const location = useRouter();

		const { asPath } = location;

		useEffect(() => {
			const lastRedirectUrl = false;

			// if (
			// 	asPath.indexOf('/login') === -1 &&
			// 	asPath.indexOf('/signup') === -1 &&
			// 	asPath.indexOf('/iforgot') === -1
			// ) {
			// 	lastRedirectUrl = true;
			// }

			__setURLLocationNRedirect(asPath, lastRedirectUrl);

			const page = `/${asPath}${asPath.endsWith('/') ? '' : '/'}`;

			__pushToMonitorEvents('Navigate Page');

			trackPage(page);
		}, [asPath, __setURLLocationNRedirect, __pushToMonitorEvents]);

		return null;
	}
);

export default connect(
	'',
	actionsCombiner(monitorActions, redirectURLActions)
)(TrackerComp);
